import { render, staticRenderFns } from "./Classes.vue?vue&type=template&id=8d04c7b6&scoped=true&"
import script from "./Classes.vue?vue&type=script&lang=js&"
export * from "./Classes.vue?vue&type=script&lang=js&"
import style0 from "./Classes.vue?vue&type=style&index=0&id=8d04c7b6&prod&lang=scss&scoped=true&"
import style1 from "./Classes.vue?vue&type=style&index=1&id=8d04c7b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d04c7b6",
  null
  
)

export default component.exports